export const GITHUB_OAUTH_URL = 'https://github.com/login/oauth/authorize';
export const QUERY_KEY_SESSION = Object.freeze(['auth', 'session']);
